module.exports = __webpack_public_path__ + "assets/images/numberofChairs-01.2425b7ee1de202b5d0b7794654aef6a4.svg";